import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locations: {
    loading: false,
    error: null,
    data: null,
  },
};

const locationsSlice = createSlice({
  name: "afmsLocations",
  initialState,
  reducers: {
    locationsStart: (state) => {
      state.locations.loading = true;
      state.locations.error = null;
    },
    locationsSuccess: (state, action) => {
      state.locations.loading = false;
      state.locations.data = action.payload;
      state.locations.error = null;
    },
    locationsFailure: (state, action) => {
      state.locations.loading = false;
      state.locations.error = action.payload;
    },
    locationsReset: (state) => {
      state.locations = initialState.locations;
    },
  },
});

export const {
  locationsStart,
  locationsSuccess,
  locationsFailure,
  locationsReset,
} = locationsSlice.actions;

export default locationsSlice.reducer;
